import React, { useState, useEffect, useMemo, useRef } from "react";
import { API_BASE_URL, getSheetUrl } from "./constants/adminConstants";
import "./css/adminStyles.css";

const FALLBACK_ROWS = [
  { country_code: "LK", country_name: "Sri Lanka", visa_type: "Tourist Visa", effective_date: "2024-12-01", old_fee: 50, new_fee: 60, currency: "USD", change_type: "increase", percentage: 20, reason: "Government revision of tourism promotion levy and administrative processing charges" },
  { country_code: "LK", country_name: "Sri Lanka", visa_type: "Business Visa", effective_date: "2024-12-01", old_fee: 75, new_fee: 85, currency: "USD", change_type: "increase", percentage: 13.3, reason: "Enhanced security verification procedures and documentation processing costs" },
  { country_code: "US", country_name: "United States", visa_type: "Tourist Visa", effective_date: "2024-06-17", old_fee: 160, new_fee: 185, currency: "USD", change_type: "increase", percentage: 15.6, reason: "Department of State fee adjustment for consular services operational costs" },
  { country_code: "US", country_name: "United States", visa_type: "Student Visa", effective_date: "2024-06-17", old_fee: 160, new_fee: 185, currency: "USD", change_type: "increase", percentage: 15.6, reason: "Adjustment reflecting actual cost of providing non-immigrant visa services" },
  { country_code: "GB", country_name: "United Kingdom", visa_type: "Tourist Visa", effective_date: "2024-10-04", old_fee: 115, new_fee: 133, currency: "GBP", change_type: "increase", percentage: 15.7, reason: "Home Office fee review to ensure sustainable funding for border and immigration system" },
  { country_code: "GB", country_name: "United Kingdom", visa_type: "Student Visa", effective_date: "2024-10-04", old_fee: 363, new_fee: 490, currency: "GBP", change_type: "increase", percentage: 35, reason: "Adjustment aligned with inflation and increased processing requirements" },
  { country_code: "GB", country_name: "United Kingdom", visa_type: "Work Visa", effective_date: "2024-10-04", old_fee: 719, new_fee: 827, currency: "GBP", change_type: "increase", percentage: 15, reason: "Skilled worker visa fee revision per immigration and nationality regulations" },
  { country_code: "CA", country_name: "Canada", visa_type: "Tourist Visa", effective_date: "2024-04-01", old_fee: 100, new_fee: 100, currency: "CAD", change_type: "decrease", percentage: 0, reason: "No change - maintained current fee structure for visitor visas" },
  { country_code: "CA", country_name: "Canada", visa_type: "Student Visa", effective_date: "2024-01-01", old_fee: 150, new_fee: 150, currency: "CAD", change_type: "decrease", percentage: 0, reason: "Study permit processing fee maintained at current level" },
  { country_code: "AU", country_name: "Australia", visa_type: "Tourist Visa", effective_date: "2024-07-01", old_fee: 190, new_fee: 210, currency: "AUD", change_type: "increase", percentage: 10.5, reason: "Annual indexation adjustment per Department of Home Affairs regulations" },
  { country_code: "AU", country_name: "Australia", visa_type: "Student Visa", effective_date: "2024-07-01", old_fee: 710, new_fee: 1600, currency: "AUD", change_type: "increase", percentage: 125.4, reason: "Significant fee increase to fund education sector reforms and migration policy changes" },
  { country_code: "AU", country_name: "Australia", visa_type: "Work Visa", effective_date: "2024-07-01", old_fee: 3035, new_fee: 3115, currency: "AUD", change_type: "increase", percentage: 2.6, reason: "Indexation-based adjustment for temporary skill shortage visa category" },
  { country_code: "DE", country_name: "Germany", visa_type: "Tourist Visa", effective_date: "2024-01-01", old_fee: 80, new_fee: 90, currency: "EUR", change_type: "increase", percentage: 12.5, reason: "Schengen visa fee increase implemented across all EU member states" },
  { country_code: "DE", country_name: "Germany", visa_type: "Student Visa", effective_date: "2024-01-01", old_fee: 75, new_fee: 75, currency: "EUR", change_type: "decrease", percentage: 0, reason: "Student visa fee maintained at preferential rate for educational purposes" },
  { country_code: "FR", country_name: "France", visa_type: "Tourist Visa", effective_date: "2024-02-01", old_fee: 80, new_fee: 90, currency: "EUR", change_type: "increase", percentage: 12.5, reason: "European Commission approved Schengen visa fee harmonization" },
  { country_code: "JP", country_name: "Japan", visa_type: "Tourist Visa", effective_date: "2024-04-01", old_fee: 3000, new_fee: 3000, currency: "JPY", change_type: "decrease", percentage: 0, reason: "No change - single entry visa fee maintained at current level" },
  { country_code: "JP", country_name: "Japan", visa_type: "Business Visa", effective_date: "2024-04-01", old_fee: 5500, new_fee: 5500, currency: "JPY", change_type: "decrease", percentage: 0, reason: "Multiple entry business visa fee unchanged for fiscal year 2024" },
  { country_code: "SG", country_name: "Singapore", visa_type: "Tourist Visa", effective_date: "2024-03-01", old_fee: 30, new_fee: 30, currency: "SGD", change_type: "decrease", percentage: 0, reason: "Processing fee maintained at current competitive rate" },
  { country_code: "AE", country_name: "United Arab Emirates", visa_type: "Tourist Visa", effective_date: "2024-05-01", old_fee: 90, new_fee: 110, currency: "USD", change_type: "increase", percentage: 22.2, reason: "Enhanced e-visa platform integration and security processing fees" },
  { country_code: "NZ", country_name: "New Zealand", visa_type: "Tourist Visa", effective_date: "2024-08-01", old_fee: 211, new_fee: 249, currency: "NZD", change_type: "increase", percentage: 18, reason: "Immigration New Zealand cost recovery adjustment" },
  { country_code: "NZ", country_name: "New Zealand", visa_type: "Student Visa", effective_date: "2024-08-01", old_fee: 375, new_fee: 430, currency: "NZD", change_type: "increase", percentage: 14.7, reason: "Operational cost review for international student processing" },
  { country_code: "IN", country_name: "India", visa_type: "Tourist Visa", effective_date: "2024-06-01", old_fee: 25, new_fee: 30, currency: "USD", change_type: "increase", percentage: 20, reason: "E-visa platform enhancement and tourist facilitation charges" },
  { country_code: "IN", country_name: "India", visa_type: "Business Visa", effective_date: "2024-06-01", old_fee: 80, new_fee: 100, currency: "USD", change_type: "increase", percentage: 25, reason: "Business visa processing infrastructure development levy" },
  { country_code: "TH", country_name: "Thailand", visa_type: "Tourist Visa", effective_date: "2024-09-01", old_fee: 60, new_fee: 60, currency: "USD", change_type: "decrease", percentage: 0, reason: "Standard tourist visa fee maintained to support tourism sector" },
  { country_code: "TH", country_name: "Thailand", visa_type: "Visa on Arrival", effective_date: "2024-09-01", old_fee: 35, new_fee: 35, currency: "USD", change_type: "decrease", percentage: 0, reason: "Visa on arrival fee unchanged for eligible nationalities" },
  { country_code: "VN", country_name: "Vietnam", visa_type: "E-Visa", effective_date: "2024-08-15", old_fee: 25, new_fee: 50, currency: "USD", change_type: "increase", percentage: 100, reason: "E-visa system upgrade and extended validity period implementation" },
  { country_code: "MY", country_name: "Malaysia", visa_type: "Tourist Visa", effective_date: "2024-07-01", old_fee: 15, new_fee: 20, currency: "USD", change_type: "increase", percentage: 33.3, reason: "Immigration processing fee revision for enhanced security protocols" },
  { country_code: "MY", country_name: "Malaysia", visa_type: "E-Visa", effective_date: "2024-07-01", old_fee: 20, new_fee: 25, currency: "USD", change_type: "increase", percentage: 25, reason: "Digital platform maintenance and electronic verification system costs" },
  { country_code: "LK", country_name: "Sri Lanka", visa_type: "Transit Visa", effective_date: "2024-12-01", old_fee: 25, new_fee: 30, currency: "USD", change_type: "increase", percentage: 20, reason: "Airport transit processing and facilitation service fees updated" },
  { country_code: "AU", country_name: "Australia", visa_type: "Work Visa", effective_date: "2024-12-15", old_fee: 3115, new_fee: 3235, currency: "AUD", change_type: "increase", percentage: 3.9, reason: "Mid-year indexation adjustment per migration regulations" },
].map((r, i) => ({ ...r, id: -(i + 1) }));

const RECORD_COLUMNS = [
  { key: "country_code", label: "Country" },
  { key: "visa_type", label: "Visa Type" },
  { key: "effective_date", label: "Effective Date", type: "date" },
  { key: "old_fee", label: "Old Fee", type: "number" },
  { key: "new_fee", label: "New Fee", type: "number" },
  { key: "currency", label: "Currency" },
  { key: "change_type", label: "Change Type" },
  { key: "percentage", label: "Percentage", type: "number" },
  { key: "reason", label: "Reason" },
];

const CURRENCY_OPTIONS = ["AED","AFN","ALL","AMD","ANG","AOA","ARS","AUD","AWG","AZN","BAM","BBD","BDT","BGN","BHD","BIF","BMD","BND","BOB","BRL","BSD","BTN","BWP","BYN","BZD","CAD","CDF","CHF","CLP","CNY","COP","CRC","CUP","CVE","CZK","DJF","DKK","DOP","DZD","EGP","ERN","ETB","EUR","FJD","FKP","FOK","GBP","GEL","GGP","GHS","GIP","GMD","GNF","GTQ","GYD","HKD","HNL","HRK","HTG","HUF","IDR","ILS","IMP","INR","IQD","IRR","ISK","JEP","JMD","JOD","JPY","KES","KGS","KHR","KID","KMF","KRW","KWD","KYD","KZT","LAK","LBP","LKR","LRD","LSL","LYD","MAD","MDL","MGA","MKD","MMK","MNT","MOP","MRU","MUR","MVR","MWK","MXN","MYR","MZN","NAD","NGN","NIO","NOK","NPR","NZD","OMR","PAB","PEN","PGK","PHP","PKR","PLN","PYG","QAR","RON","RSD","RUB","RWF","SAR","SBD","SCR","SDG","SEK","SGD","SHP","SLE","SLL","SOS","SRD","SSP","STN","SYP","SZL","THB","TJS","TMT","TND","TOP","TRY","TTD","TVD","TWD","TZS","UAH","UGX","USD","UYU","UZS","VES","VND","VUV","WST","XAF","XCD","XDR","XOF","XPF","YER","ZAR","ZMW"];

function getCurrencySymbol(code) {
  try { return new Intl.NumberFormat("en", { style: "currency", currency: code, minimumFractionDigits: 0 }).formatToParts(0).find(p => p.type === "currency")?.value || code; } catch { return code; }
}

function AdminGovtFeeHistoryEditor({ user, section, onBack }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [countryFilter, setCountryFilter] = useState("");
  const [visaTypeFilter, setVisaTypeFilter] = useState("");
  const [showSuccessOverlay, setShowSuccessOverlay] = useState(false);
  const [successTitle, setSuccessTitle] = useState("");
  const [activeTab, setActiveTab] = useState("countries");
  const [countryMasterList, setCountryMasterList] = useState([]);
  const [visaTypeMasterList, setVisaTypeMasterList] = useState([]);
  const [countrySearch, setCountrySearch] = useState("");
  const [visaTypeSearch, setVisaTypeSearch] = useState("");
  const [lastUpdated, setLastUpdated] = useState("");
  const [searchOpen, setSearchOpen] = useState(false);
  const searchRef = useRef(null);
  const dragRef = useRef(null);
  const tabBarRef = useRef(null);
  useEffect(() => {
    const el = tabBarRef.current;
    if (!el) return;
    const wheelHandler = (e) => {
      if (e.deltaY !== 0) { e.preventDefault(); el.scrollLeft += e.deltaY; }
    };
    el.addEventListener("wheel", wheelHandler, { passive: false });
    return () => el.removeEventListener("wheel", wheelHandler);
  }, []);
  const tabDragRef = useRef(null);
  const countryCurrencyMapRef = useRef(null);

  useEffect(() => {
    if (searchOpen && searchRef.current) {
      searchRef.current.focus();
    }
  }, [searchOpen]);

  useEffect(() => { loadRows(); }, []);
	  useEffect(() => {
    if (!countryCurrencyMapRef.current) {
      fetch(`${API_BASE_URL}/countries/external`)
        .then((r) => r.json())
        .then((list) => {
          const map = {};
          for (const c of list) {
            const name = (c.name?.common || "").toLowerCase();
            const currencies = c.currencies ? Object.keys(c.currencies) : [];
            if (name && currencies.length > 0) map[name] = currencies[0];
          }
          countryCurrencyMapRef.current = map;
        })
        .catch(() => {
          countryCurrencyMapRef.current = {};
        });
    }
  }, []);

  const extractMasterLists = (data) => {
    const seenC = {};
    const cl = data.filter((r) => {
      if (!r.country_code) return false;
      const k = r.country_code + "|" + r.country_name;
      if (seenC[k]) return false;
      seenC[k] = true;
      return true;
    }).map((r) => ({ code: r.country_code, name: r.country_name, currency: r.currency || "USD" }));
    setCountryMasterList(cl);
    const seenV = {};
    const vl = data.filter((r) => {
      if (!r.visa_type) return false;
      if (seenV[r.visa_type]) return false;
      seenV[r.visa_type] = true;
      return true;
    }).map((r) => r.visa_type);
    setVisaTypeMasterList(vl);
  };

  const fetchLastUpdated = async () => {
    try {
      const r = await fetch(`${API_BASE_URL.replace('/tvc', '')}/config`);
      if (r.ok) { const d = await r.json(); const ts = d?.data?.govtFeeLastUpdated || d?.govtFeeLastUpdated; if (ts) setLastUpdated(new Date(ts).toLocaleDateString("en-GB")); }
    } catch (_) {}
  };

  const loadRows = async () => {
    await fetchLastUpdated();
    const token = sessionStorage.getItem("tvc_token");
    try {
      const res = await fetch(`${API_BASE_URL}/govt-fee-history`, { headers: { Authorization: `Bearer ${token}` } });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      let loaded = null;
      if (data && Array.isArray(data.rows)) loaded = data.rows;
      else if (data && Array.isArray(data.data)) loaded = data.data;
      else if (Array.isArray(data)) loaded = data;
      if (loaded && loaded.length > 0) { setRows(loaded.map((r, i) => ({ ...r, id: r.id ?? -(i + 1) }))); extractMasterLists(loaded); }
      else { setRows(FALLBACK_ROWS); extractMasterLists(FALLBACK_ROWS); }
    } catch (err) {
      if (err.message === "Failed to fetch") setMessage("Network error — using fallback data.");
      else if (err.message.startsWith("HTTP")) setMessage(`Server error — using fallback data.`);
      else setMessage("Failed to load — using fallback data.");
      try {
        const fallbackRes = await fetch(`${API_BASE_URL.replace('/tvc', '')}/config`);
        if (fallbackRes.ok) {
          const fallbackData = await fallbackRes.json();
          const fb = Array.isArray(fallbackData?.data?.govtFeeHistory) ? fallbackData.data.govtFeeHistory : null;
          if (fb && fb.length > 0) { setRows(fb.map((r, i) => ({ ...r, id: r.id ?? -(i + 1) }))); extractMasterLists(fb); return; }
        }
      } catch (_) {}
      setRows(FALLBACK_ROWS);
      extractMasterLists(FALLBACK_ROWS);
    }
    finally { setLoading(false); }
  };

  const handleOpenSheet = () => { window.open(getSheetUrl("governmentFee"), "_blank", "noopener,noreferrer"); };

  const handlePushToSheet = async () => {
    const token = sessionStorage.getItem("tvc_token");
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/govt-fee-history/push-sheet`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify({ rows, countries: countryMasterList, visaTypes: visaTypeMasterList }),
      });
      const data = await res.json();
      setMessage(data.success ? "Pushed to Google Sheet!" : data.error || "Push failed.");
    } catch (err) { setMessage("Push error."); }
    finally { setLoading(false); }
  };

  const handlePullFromSheet = async () => {
    const token = sessionStorage.getItem("tvc_token");
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/govt-fee-history/pull-sheet`, { method: "POST", headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      if (data.success && data.rows) {
        setRows(data.rows.map((r, i) => ({ ...r, id: -(i + 1) })));
        if (data.countries) setCountryMasterList(data.countries);
        if (data.visaTypes) setVisaTypeMasterList(data.visaTypes);
        setMessage("Pulled from sheet. Review and click Publish to save.");
      } else { setMessage(data.error || "Pull failed."); }
    } catch (err) { setMessage("Pull error."); }
    finally { setLoading(false); }
  };

  const handleRowChange = (index, key, value) => {
    setRows((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [key]: value };
      return updated;
    });
  };

  const handleAddRow = () => {
    setPendingInsertIndex(null);
    setEditingRowIndex(null);
    setEditingRow({ id: -(Date.now()), country_code: "", country_name: "", visa_type: "", effective_date: "", old_fee: 0, new_fee: 0, currency: "USD", change_type: "increase", percentage: "", reason: "" });
  };

  const handleDeleteRow = (index) => {
    setRows((prev) => prev.filter((_, i) => i !== index));
  };

  const handleRecordMoveUp = (index) => {
    if (index === 0) return;
    setRows((prev) => { const arr = [...prev]; [arr[index - 1], arr[index]] = [arr[index], arr[index - 1]]; return arr; });
  };

  const handleRecordMoveDown = (index) => {
    if (index === rows.length - 1) return;
    setRows((prev) => { const arr = [...prev]; [arr[index], arr[index + 1]] = [arr[index + 1], arr[index]]; return arr; });
  };

  const handleRecordAddBefore = (index) => {
    setPendingInsertIndex(index);
    setEditingRowIndex(null);
    setEditingRow({ id: -(Date.now()), country_code: "", country_name: "", visa_type: "", effective_date: "", old_fee: 0, new_fee: 0, currency: "USD", change_type: "increase", percentage: "", reason: "" });
  };

  const handleRecordAddAfter = (index) => {
    setPendingInsertIndex(index + 1);
    setEditingRowIndex(null);
    setEditingRow({ id: -(Date.now()), country_code: "", country_name: "", visa_type: "", effective_date: "", old_fee: 0, new_fee: 0, currency: "USD", change_type: "increase", percentage: "", reason: "" });
  };

  const [editingRow, setEditingRow] = useState(null);
  const [editingRowIndex, setEditingRowIndex] = useState(null);
  const [pendingInsertIndex, setPendingInsertIndex] = useState(null);

  const handleOpenEdit = (index) => {
    setPendingInsertIndex(null);
    setEditingRowIndex(index);
    const row = rows[index];
    const oldNum = Number(row.old_fee);
    const newNum = Number(row.new_fee);
    let pct = row.percentage;
    let ct = row.change_type;
    if (oldNum > 0) {
      pct = ((newNum - oldNum) / oldNum * 100).toFixed(1);
      ct = newNum >= oldNum ? "increase" : "decrease";
    }
    setEditingRow({ ...row, percentage: pct, change_type: ct });
  };

  const handleCloseEdit = () => {
    setEditingRow(null);
    setEditingRowIndex(null);
    setPendingInsertIndex(null);
  };

  const handleEditFieldChange = (key, value) => {
    setEditingRow((prev) => {
      const updated = { ...prev, [key]: value };
      if ((key === "old_fee" || key === "new_fee") && updated.old_fee && updated.new_fee) {
        const oldNum = Number(updated.old_fee);
        const newNum = Number(updated.new_fee);
        if (oldNum > 0) {
          updated.percentage = ((newNum - oldNum) / oldNum * 100).toFixed(1);
        }
        updated.change_type = newNum >= oldNum ? "increase" : "decrease";
      }
      return updated;
    });
  };

  const handleSaveEdit = () => {
    if (!editingRow) return;
    const todayStr = new Date().toISOString().split("T")[0];
    const rowToSave = { ...editingRow, effective_date: todayStr };
    if (pendingInsertIndex !== null) {
      setRows((prev) => {
        const arr = [...prev];
        arr.splice(pendingInsertIndex, 0, rowToSave);
        return arr;
      });
    } else if (editingRowIndex === null) {
      setRows((prev) => [...prev, rowToSave]);
    } else {
      setRows((prev) => {
        const arr = [...prev];
        arr[editingRowIndex] = rowToSave;
        return arr;
      });
    }
    handleCloseEdit();
  };

  const computeDerived = (r) => {
    const oldNum = Number(r.old_fee);
    const newNum = Number(r.new_fee);
    const pct = oldNum > 0 ? ((newNum - oldNum) / oldNum * 100).toFixed(1) : r.percentage || "";
    const ct = oldNum > 0 && newNum >= oldNum ? "increase" : "decrease";
    return { percentage: pct, change_type: ct };
  };

  const handleSubmit = async () => {
    setSaving(true);
    setMessage("");
    const token = sessionStorage.getItem("tvc_token");
    try {
      const payload = rows.map((r) => {
        const derived = computeDerived(r);
        return {
          country_code: r.country_code, country_name: r.country_name || "", visa_type: r.visa_type,
          effective_date: r.effective_date, old_fee: Number(r.old_fee) || 0, new_fee: Number(r.new_fee) || 0,
          currency: r.currency || countryMasterList.find((c) => c.code === r.country_code)?.currency || "USD", change_type: derived.change_type,
          percentage: derived.percentage, reason: r.reason || "",
        };
      });
      const res = await fetch(`${API_BASE_URL}/govt-fee-history/bulk-save`, {
        method: "POST", headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ rows: payload }),
      });
      if (!res.ok) { const t = await res.text(); setMessage(`Error: ${t.substring(0, 200)}`); return; }
      const saveRes = await res.json();
      if (saveRes.last_updated) setLastUpdated(new Date(saveRes.last_updated).toLocaleDateString("en-GB"));
      setSuccessTitle("Changes Published");
      setShowSuccessOverlay(true);
      loadRows();
    } catch (err) { setMessage("Network error."); }
    finally { setSaving(false); }
  };

  // Country master list handlers
  const handleCountryNameChange = (code, newName) => {
    setCountryMasterList((prev) => prev.map((c) =>
      c.code === code ? { ...c, name: newName } : c
    ));
  };
  const handleCountryCurrencyChange = (code, currency) => {
    setCountryMasterList((prev) => prev.map((c) =>
      c.code === code ? { ...c, currency } : c
    ));
  };
  const handleCountryNameBlur = (code) => {
    setCountryMasterList((prev) => {
      let arr = prev.map((c) => {
        if (c.code !== code) return c;
        const derivedCode = c.code.startsWith("NEW_") && c.name ? c.name.substring(0, 2).toUpperCase() : c.code;
        const map = countryCurrencyMapRef.current;
        const autoCurrency = c.name && map ? map[c.name.toLowerCase()] : null;
        return { ...c, code: derivedCode, currency: autoCurrency || c.currency || "USD" };
      });
      return [...arr].sort((a, b) => (a.name || "").localeCompare(b.name || ""));
    });
  };
  const handleCountryDelete = (code) => {
    setCountryMasterList((prev) => prev.filter((c) => c.code !== code));
  };
  const handleCountryMoveUp = (idx) => {
    if (idx === 0) return;
    setCountryMasterList((prev) => { const arr = [...prev]; [arr[idx - 1], arr[idx]] = [arr[idx], arr[idx - 1]]; return arr; });
  };
  const handleCountryMoveDown = (idx) => {
    setCountryMasterList((prev) => {
      if (idx === prev.length - 1) return prev;
      const arr = [...prev]; [arr[idx], arr[idx + 1]] = [arr[idx + 1], arr[idx]]; return arr;
    });
  };
  const handleOpenCountryAdd = () => {
    const tmpCode = `NEW_${Date.now()}`;
    setCountryMasterList((prev) => [...prev, { code: tmpCode, name: "", currency: "USD" }]);
  };
  const handleOpenCountryAddBefore = (idx) => {
    const tmpCode = `NEW_${Date.now()}`;
    setCountryMasterList((prev) => { const arr = [...prev]; arr.splice(idx, 0, { code: tmpCode, name: "", currency: "USD" }); return arr; });
  };
  const handleOpenCountryAddAfter = (idx) => {
    const tmpCode = `NEW_${Date.now()}`;
    setCountryMasterList((prev) => { const arr = [...prev]; arr.splice(idx + 1, 0, { code: tmpCode, name: "", currency: "USD" }); return arr; });
  };

  // Visa Type master list handlers
  const handleVisaTypeChange = (oldType, newType) => {
    setVisaTypeMasterList((prev) => prev.map((t) => t === oldType ? newType : t));
  };
  const handleVisaTypeBlur = () => {
    setVisaTypeMasterList((prev) => [...prev].sort((a, b) => a.localeCompare(b)));
  };
  const handleVisaTypeDelete = (type) => {
    setVisaTypeMasterList((prev) => prev.filter((t) => t !== type));
  };
  const handleVisaTypeMoveUp = (idx) => {
    if (idx === 0) return;
    setVisaTypeMasterList((prev) => { const arr = [...prev]; [arr[idx - 1], arr[idx]] = [arr[idx], arr[idx - 1]]; return arr; });
  };
  const handleVisaTypeMoveDown = (idx) => {
    setVisaTypeMasterList((prev) => {
      if (idx === prev.length - 1) return prev;
      const arr = [...prev]; [arr[idx], arr[idx + 1]] = [arr[idx + 1], arr[idx]]; return arr;
    });
  };
  const handleOpenVisaTypeAdd = () => {
    const tmpType = `NEW_${Date.now()}`;
    setVisaTypeMasterList((prev) => [...prev, tmpType]);
  };
  const handleOpenVisaTypeAddBefore = (idx) => {
    const tmpType = `NEW_${Date.now()}`;
    setVisaTypeMasterList((prev) => { const arr = [...prev]; arr.splice(idx, 0, tmpType); return arr; });
  };
  const handleOpenVisaTypeAddAfter = (idx) => {
    const tmpType = `NEW_${Date.now()}`;
    setVisaTypeMasterList((prev) => { const arr = [...prev]; arr.splice(idx + 1, 0, tmpType); return arr; });
  };

  const filteredRows = useMemo(() => {
    return rows.filter((r) => {
      const term = searchTerm.toLowerCase();
      const matchesSearch = !term || (r.country_name && r.country_name.toLowerCase().includes(term)) || (r.visa_type && r.visa_type.toLowerCase().includes(term)) || (r.reason && r.reason.toLowerCase().includes(term));
      const matchesCountry = !countryFilter || r.country_code === countryFilter || r.country_name === countryFilter;
      const matchesVisa = !visaTypeFilter || r.visa_type === visaTypeFilter;
      return matchesSearch && matchesCountry && matchesVisa;
    });
  }, [rows, searchTerm, countryFilter, visaTypeFilter]);

  const availableCountries = useMemo(() => [...countryMasterList].sort((a, b) => a.name.localeCompare(b.name)), [countryMasterList]);

  if (loading) return <div className="AdminEmptyState">Loading...</div>;

  const tabs = [
    { key: "countries", label: "Countries" },
    { key: "visaTypes", label: "Visa Types" },
    { key: "records", label: "Records" },
  ];

  return (
    <div className="AdminCard">
      <div className="AdminCardHeader">
        <h3 className="AdminFooterH3">Government Fee Editor
          {(() => {
            const countMap = { countries: countryMasterList.length, visaTypes: visaTypeMasterList.length, records: rows.length };
            return <span className="AdminCountBadge">{countMap[activeTab] || 0}</span>;
          })()}
        </h3>
        <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: "8px" }}>
          <button className="AdminButton AdminButtonSmall AdminSubmitBtn" onClick={handleSubmit} disabled={saving} style={{ whiteSpace: "nowrap" }}>
            {saving ? "Saving..." : "Publish"}
          </button>
          <button className="AdminButton AdminButtonSmall AdminSheetBtn" onClick={handleOpenSheet}>Google Sheet</button>
          <button className="AdminSheetIconBtn" onClick={handlePushToSheet} disabled={loading} title="Push to Sheet">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
          </button>
          <button className="AdminSheetIconBtn" onClick={handlePullFromSheet} disabled={loading} title="Pull from Sheet">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
          </button>
        </div>
      </div>

      {message && <p className={`AdminMsgBox ${message.includes("success") || message.includes("Pushed") ? "AdminSuccess" : "AdminError"}`}>{message}</p>}

      <div className="AdminTabBar" ref={tabBarRef} style={{ display: "flex", gap: 0, borderBottom: "2px solid #e2e8f0", marginBottom: 16 }}>
        {tabs.map((tab) => (
          <button
            key={tab.key}
            draggable
            onDragStart={(e) => { tabDragRef.current = tab.key; e.target.style.opacity = '0.5'; }}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => {
              e.preventDefault();
              const fromId = tabDragRef.current;
              if (!fromId || fromId === tab.key) return;
              setActiveTab(tab.key);
            }}
            onDragEnd={(e) => { e.target.style.opacity = '1'; tabDragRef.current = null; }}
            className={`AdminTabBtn ${activeTab === tab.key ? "AdminTabBtnActive" : ""}`}
            onClick={() => setActiveTab(tab.key)}
            style={{
              padding: "10px 20px", border: "none", background: activeTab === tab.key ? "#1B2A4A" : "transparent",
              color: activeTab === tab.key ? "#fff" : "#64748b", cursor: "grab", fontSize: 14, fontWeight: 600,
              borderRadius: "8px 8px 0 0", transition: "all 0.2s",
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === "countries" && (          <div className="AdminCardMb">
          <div className="AdminSectionHeader">
            <h4 className="AdminSectionTitle">Countries</h4>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div className={`AdminPillSearchWrap ${searchOpen ? 'is-open' : ''}`}>
                <span className="AdminPillSearchIcon">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                  </svg>
                </span>
                <input ref={searchRef} type="text" className="AdminPillSearch" placeholder="Search countries..." value={countrySearch} onChange={(e) => setCountrySearch(e.target.value)} onBlur={() => { setCountrySearch(""); setTimeout(() => setSearchOpen(false), 200) }} />
                {!searchOpen && <button className="AdminPillSearchOverlay" onClick={() => setSearchOpen(true)} type="button" aria-label="Search" />}
              </div>
              <button className="AdminButton AdminButtonSmall AdminButtonSecondary AdminAddRowBtn" onClick={handleOpenCountryAdd}>+ Add Row</button>
            </div>
          </div>
          <div className="AdminTableScrollWrap">
            <div className="AdminTableScroll">
              <table className="AdminTable AdminTableEditor" style={{ minWidth: 700 }}>
                <thead>
                  <tr>
                    <th className="AdminThOrder" style={{textAlign:"center"}}>Order</th>
                    <th style={{textAlign:"left"}}>Country Name</th>
                    <th style={{textAlign:"left"}}>Currency</th>
                    <th style={{textAlign:"center"}}>Symbol</th>
                    <th className="AdminThActions" style={{textAlign:"center"}}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {countryMasterList.filter((c) => !countrySearch || (c.code || "").toLowerCase().includes(countrySearch.toLowerCase()) || (c.name || "").toLowerCase().includes(countrySearch.toLowerCase())).map((c, idx) => (
                    <tr key={c.code || idx}>
                      <td style={{textAlign:"center"}}>
                        <div className="AdminOrderBtns" style={{justifyContent:"center"}}>
                          <button className="AdminMoveBtn" onClick={() => handleCountryMoveUp(idx)} disabled={idx === 0} title="Move up">&#8593;</button>
                          <button className="AdminMoveBtn" onClick={() => handleCountryMoveDown(idx)} disabled={idx === countryMasterList.length - 1} title="Move down">&#8595;</button>
                        </div>
                      </td>
                      <td style={{textAlign:"left"}}>
                        <input
                          className="AdminInput AdminTableInput"
                          value={c.name || ""}
                          onChange={(e) => handleCountryNameChange(c.code, e.target.value)}
                          onBlur={() => handleCountryNameBlur(c.code)}
                          placeholder="Country name"
                          style={{minWidth:140,fontSize:13,textAlign:"left"}}
                        />
                      </td>
                      <td style={{textAlign:"left"}}>
                        <input className="AdminInput AdminTableInput" value={c.currency || ""} onChange={(e) => handleCountryCurrencyChange(c.code, e.target.value)} placeholder="e.g. USD" style={{fontSize:13,minWidth:80,textTransform:"uppercase",textAlign:"left"}} />
                      </td>
                      <td style={{fontSize:18,fontWeight:600,textAlign:"center"}}>{c.currency ? getCurrencySymbol(c.currency) : ""}</td>
                      <td style={{textAlign:"center"}}>
                        <div className="AdminActionBtns" style={{justifyContent:"center"}}>
                          <button className="AdminIconBtn AdminIconBtnBlue" onClick={() => handleOpenCountryAddBefore(idx)} title="Add row before">&#9650;+</button>
                          <button className="AdminIconBtn AdminIconBtnBlue" onClick={() => handleOpenCountryAddAfter(idx)} title="Add row after">&#9660;+</button>
                          <button className="AdminIconBtn AdminIconBtnRed" onClick={() => handleCountryDelete(c.code)} title="Delete country">&#10005;</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          {countryMasterList.length === 0 && <div className="AdminEmptyState">No countries found.</div>}
        </div>
      )}

      {activeTab === "visaTypes" && (          <div className="AdminCardMb">
          <div className="AdminSectionHeader">
            <h4 className="AdminSectionTitle">Visa Types</h4>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div className={`AdminPillSearchWrap ${searchOpen ? 'is-open' : ''}`}>
                <span className="AdminPillSearchIcon">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                  </svg>
                </span>
                <input ref={searchRef} type="text" className="AdminPillSearch" placeholder="Search visa types..." value={visaTypeSearch} onChange={(e) => setVisaTypeSearch(e.target.value)} onBlur={() => { setVisaTypeSearch(""); setTimeout(() => setSearchOpen(false), 200) }} />
                {!searchOpen && <button className="AdminPillSearchOverlay" onClick={() => setSearchOpen(true)} type="button" aria-label="Search" />}
              </div>
              <button className="AdminButton AdminButtonSmall AdminButtonSecondary AdminAddRowBtn" onClick={handleOpenVisaTypeAdd}>+ Add Row</button>
            </div>
          </div>
          <div className="AdminTableScrollWrap">
            <div className="AdminTableScroll">
              <table className="AdminTable AdminTableEditor" style={{ minWidth: 400 }}>
                <thead>
                  <tr>
                    <th className="AdminThOrder">Order</th>
                    <th>Visa Type</th>
                    <th className="AdminThActions">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {visaTypeMasterList.filter((v) => !visaTypeSearch || v.toLowerCase().includes(visaTypeSearch.toLowerCase())).map((v, idx) => (
                    <tr key={"vt-" + idx}>
                      <td>
                        <div className="AdminOrderBtns">
                          <button className="AdminMoveBtn" onClick={() => handleVisaTypeMoveUp(idx)} disabled={idx === 0} title="Move up">&#8593;</button>
                          <button className="AdminMoveBtn" onClick={() => handleVisaTypeMoveDown(idx)} disabled={idx === visaTypeMasterList.length - 1} title="Move down">&#8595;</button>
                        </div>
                      </td>
                      <td>
                        <input
                          className="AdminInput AdminTableInput"
                          value={v.startsWith("NEW_") ? "" : v}
                          onChange={(e) => handleVisaTypeChange(v, e.target.value)}
                          onBlur={handleVisaTypeBlur}
                          placeholder="Visa type"
                          style={{minWidth:160,fontSize:13,fontWeight:600}}
                        />
                      </td>
                      <td>
                        <div className="AdminActionBtns">
                          <button className="AdminIconBtn AdminIconBtnBlue" onClick={() => handleOpenVisaTypeAddBefore(idx)} title="Add row before">&#9650;+</button>
                          <button className="AdminIconBtn AdminIconBtnBlue" onClick={() => handleOpenVisaTypeAddAfter(idx)} title="Add row after">&#9660;+</button>
                          <button className="AdminIconBtn AdminIconBtnRed" onClick={() => handleVisaTypeDelete(v)} title="Delete visa type">&#10005;</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          {visaTypeMasterList.length === 0 && <div className="AdminEmptyState">No visa types found.</div>}
        </div>
      )}

      {activeTab === "records" && (
        <div className="AdminCardMb">
          {lastUpdated && <div style={{ fontSize: 12, color: "#94a3b8", textAlign: "right", marginBottom: 8 }}>Last updated: {lastUpdated}</div>}
          <div className="AdminSectionHeader">
            <h4 className="AdminSectionTitle">Records</h4>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <div className="AdminPillFilterBar">
                  <div className={`AdminPillSearchWrap ${searchOpen ? 'is-open' : ''}`}>
                    <span className="AdminPillSearchIcon">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                      </svg>
                    </span>
                    <input ref={searchRef} type="text" className="AdminPillSearch" placeholder="Search country, visa type, reason..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} onBlur={() => { setSearchTerm(""); setTimeout(() => setSearchOpen(false), 200) }} />
                    {!searchOpen && <button className="AdminPillSearchOverlay" onClick={() => setSearchOpen(true)} type="button" aria-label="Search" />}
                  </div>
                  <div className="AdminPillGroup">
                    <div className="AdminPillFilterItem">
                      <select className="AdminPillSelect" value={countryFilter} onChange={(e) => setCountryFilter(e.target.value)}>
                        <option value="">All Countries</option>
                        {availableCountries.filter((c) => !c.code.startsWith("NEW_")).map((c) => (<option key={c.code || c.name} value={c.code || c.name}>{c.name}</option>))}
                      </select>
                      {countryFilter && <button className="AdminPillClear" onClick={() => setCountryFilter("")}>&times;</button>}
                    </div>
                    <div className="AdminPillFilterItem">
                      <select className="AdminPillSelect" value={visaTypeFilter} onChange={(e) => setVisaTypeFilter(e.target.value)}>
                        <option value="">All Visa Types</option>
                        {visaTypeMasterList.filter((t) => !t.startsWith("NEW_")).map((t) => (<option key={t} value={t}>{t}</option>))}
                      </select>
                      {visaTypeFilter && <button className="AdminPillClear" onClick={() => setVisaTypeFilter("")}>&times;</button>}
                    </div>
                  </div>
                </div>
              <button className="AdminButton AdminButtonSmall AdminButtonSecondary AdminAddRowBtn" onClick={handleAddRow}>+ Add Row</button>
            </div>
          </div>
          <div className="AdminTableScrollWrap">
            <div className="AdminTableScroll">
              <table className="AdminTable AdminTableEditor" style={{ minWidth: 1200 }}>
                <thead>
                  <tr>
                    <th className="AdminThOrder">Order</th>
                    {RECORD_COLUMNS.map((col) => (<th key={col.key}>{col.label}</th>))}
                    <th className="AdminThActions">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {[...filteredRows].sort((a, b) => (a.country_name || "").localeCompare(b.country_name || "")).map((row) => {
                    const realIdx = rows.indexOf(row);
                    return (
                    <tr key={row.id || realIdx}
                      draggable="true"
                      onDragStart={(e) => { dragRef.current = realIdx; e.dataTransfer.effectAllowed = "move"; e.currentTarget.style.opacity = "0.4"; }}
                      onDragOver={(e) => { e.preventDefault(); e.currentTarget.style.outline = "2px dashed #3b82f6"; }}
                      onDragLeave={(e) => { e.currentTarget.style.outline = ""; }}
                      onDrop={(e) => {
                        e.preventDefault(); e.currentTarget.style.opacity = ""; e.currentTarget.style.outline = "";
                        if (dragRef.current === null || dragRef.current === realIdx) { dragRef.current = null; return; }
                        setRows((prev) => { const arr = [...prev]; const [m] = arr.splice(dragRef.current, 1); arr.splice(realIdx, 0, m); return arr; });
                        dragRef.current = null;
                      }}
                      onDragEnd={(e) => { e.currentTarget.style.opacity = ""; e.currentTarget.style.outline = ""; dragRef.current = null; }}
                    >
                      <td>
                        <div className="AdminOrderBtns">
                          <button className="AdminMoveBtn" onClick={() => handleRecordMoveUp(realIdx)} disabled={realIdx === 0} title="Move up">&#8593;</button>
                          <button className="AdminMoveBtn" onClick={() => handleRecordMoveDown(realIdx)} disabled={realIdx === rows.length - 1} title="Move down">&#8595;</button>
                          <button className="AdminIconBtn AdminIconBtnBlue" onClick={() => handleOpenEdit(realIdx)} title="Edit row" style={{ marginLeft: 2, fontSize: 13 }}>&#9998;</button>
                        </div>
                      </td>
                      {RECORD_COLUMNS.map((col) => {
                        if (col.key === "percentage") {
                          const oldNum = Number(row.old_fee);
                          const newNum = Number(row.new_fee);
                          const ct = (oldNum > 0 && newNum >= oldNum) ? "increase" : "decrease";
                          const sign = ct === "increase" ? (newNum === oldNum ? "" : "+") : "-";
                          const color = ct === "increase" ? "#059669" : "#dc2626";
                          let val = row[col.key] || "";
                          if ((!val || val === "") && oldNum > 0) {
                            val = ((newNum - oldNum) / oldNum * 100).toFixed(1);
                          }
                          return (
                            <td key={col.key}>
                              <span style={{fontWeight:600,fontSize:13,color}}>
                                {sign}{val}{val ? "%" : ""}
                              </span>
                            </td>
                          );
                        }
                        let displayVal = "";
                        if (col.key === "effective_date") {
                          displayVal = row[col.key] ? new Date(row[col.key].split("T")[0]).toLocaleDateString("en-GB") : "";
                        } else if (col.key === "country_code") {
                          displayVal = row.country_name || row[col.key] || "";
                        } else if (col.key === "change_type") {
                          displayVal = Number(row.old_fee) === Number(row.new_fee) ? "-" : (row[col.key] || "");
                        } else {
                          displayVal = row[col.key] || "";
                        }
                        return (
                          <td key={col.key} style={{fontWeight: col.key === "old_fee" || col.key === "new_fee" || col.key === "percentage" ? 600 : 400, fontSize: 13}}>
                            {displayVal}
                          </td>
                        );
                      })}
                      <td>
                        <div className="AdminActionBtns">
                          <button className="AdminIconBtn AdminIconBtnBlue" onClick={() => handleRecordAddBefore(realIdx)} title="Add row before">&#9650;+</button>
                          <button className="AdminIconBtn AdminIconBtnBlue" onClick={() => handleRecordAddAfter(realIdx)} title="Add row after">&#9660;+</button>
                          <button className="AdminIconBtn AdminIconBtnRed" onClick={() => handleDeleteRow(realIdx)} title="Delete row">&#10005;</button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
                </tbody>
              </table>
            </div>
          </div>
          {filteredRows.length === 0 && <div className="AdminEmptyState">No records found.</div>}
        </div>
      )}

      {editingRow && (
        <div className="AdminOverlay" onClick={handleCloseEdit}>
          <div className="AdminOverlayCard" style={{ maxWidth: 600 }} onClick={(e) => e.stopPropagation()}>
            <div className="AdminOverlayHeader">
              <h3>{editingRowIndex === null && pendingInsertIndex === null ? "Add Record" : "Edit Record"}</h3>
              <button className="AdminIconBtn" onClick={handleCloseEdit} title="Close" style={{ fontSize: 28, width: 36, height: 36 }}>&times;</button>
            </div>
            <div style={{ padding: 20, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
              <div>
                <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#64748b", marginBottom: 4 }}>Country</label>
                <select className="AdminInput AdminTableInput" value={editingRow.country_code || ""} onChange={(e) => {
                  const newCode = e.target.value;
                  const found = countryMasterList.find((c) => c.code === newCode);
                  handleEditFieldChange("country_code", newCode);
                  handleEditFieldChange("country_name", found ? found.name : "");
                  handleEditFieldChange("currency", found && found.currency ? found.currency : "USD");
                }}>
                  <option value="">Select Country</option>
                  {countryMasterList.filter((c) => !c.code.startsWith("NEW_")).map((c) => (<option key={c.code} value={c.code}>{c.name}</option>))}
                </select>
              </div>
              <div>
                <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#64748b", marginBottom: 4 }}>Visa Type</label>
                <select className="AdminInput AdminTableInput" value={editingRow.visa_type || ""} onChange={(e) => handleEditFieldChange("visa_type", e.target.value)}>
                  <option value="">Select Visa Type</option>
                  {visaTypeMasterList.filter((t) => !t.startsWith("NEW_")).map((t) => (<option key={t} value={t}>{t}</option>))}
                </select>
              </div>
              <div>
                <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#64748b", marginBottom: 4 }}>Effective Date</label>
                <input className="AdminInput AdminTableInput" type="date" value={editingRow.effective_date ? (editingRow.effective_date.split("T")[0] || editingRow.effective_date) : ""} onChange={(e) => handleEditFieldChange("effective_date", e.target.value)} />
              </div>
              <div>
                <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#64748b", marginBottom: 4 }}>Old Fee</label>
                <input className="AdminInput AdminTableInput" type="number" value={editingRow.old_fee !== "" && editingRow.old_fee != null ? editingRow.old_fee : ""} onChange={(e) => handleEditFieldChange("old_fee", e.target.value)} />
              </div>
              <div>
                <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#64748b", marginBottom: 4 }}>New Fee</label>
                <input className="AdminInput AdminTableInput" type="number" value={editingRow.new_fee !== "" && editingRow.new_fee != null ? editingRow.new_fee : ""} onChange={(e) => handleEditFieldChange("new_fee", e.target.value)} />
              </div>
              <div>
                <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#64748b", marginBottom: 4 }}>Currency</label>
                <select className="AdminInput AdminTableInput" value={editingRow.currency || "USD"} onChange={(e) => handleEditFieldChange("currency", e.target.value)}>
                  {CURRENCY_OPTIONS.map((c) => (<option key={c} value={c}>{c}</option>))}
                </select>
              </div>
              {Number(editingRow.old_fee) !== Number(editingRow.new_fee) && <div>
                <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#64748b", marginBottom: 4 }}>Change Type</label>
                <select className="AdminInput AdminTableInput" value={editingRow.change_type || "increase"} onChange={(e) => handleEditFieldChange("change_type", e.target.value)}>
                  <option value="increase">increase</option>
                  <option value="decrease">decrease</option>
                </select>
              </div>}
              <div>
                <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#64748b", marginBottom: 4 }}>Percentage</label>
                <div style={{display:"inline-flex",alignItems:"center",gap:2,width:"100%"}}>
                  <span style={{fontSize:16,fontWeight:700,color:(editingRow.change_type||"increase") === "increase" ? "#059669" : "#dc2626",width:16,textAlign:"center",display:"inline-block"}}>
                    {(editingRow.change_type||"increase") === "increase" ? "+" : "-"}
                  </span>
                  <input
                    className="AdminInput AdminTableInput"
                    type="number"
                    step="0.1"
                    value={editingRow.percentage || ""}
                    onChange={(e) => handleEditFieldChange("percentage", e.target.value)}
                    placeholder="0.0"
                    style={{fontWeight:600,color:(editingRow.change_type||"increase") === "increase" ? "#059669" : "#dc2626",textAlign:"center"}}
                  />
                  <span style={{fontSize:13,fontWeight:600,color:(editingRow.change_type||"increase") === "increase" ? "#059669" : "#dc2626"}}>%</span>
                </div>
              </div>
              <div style={{ gridColumn: Number(editingRow.old_fee) === Number(editingRow.new_fee) ? "2" : "1 / -1" }}>
                <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#64748b", marginBottom: 4 }}>Reason</label>
                <textarea className="AdminInput AdminTableInput" rows={3} value={editingRow.reason || ""} onChange={(e) => handleEditFieldChange("reason", e.target.value)} />
              </div>
            </div>
            <div className="AdminOverlayFooter" style={{ justifyContent: "center" }}>
              <button className="AdminButton" style={{ width: 100 }} onClick={handleSaveEdit}>Save</button>
            </div>
          </div>
        </div>
      )}

      {showSuccessOverlay && (
        <div className="AdminModal" onClick={() => setShowSuccessOverlay(false)}>
          <div className="AdminModalContent" style={{ maxWidth: 400, textAlign: "center" }} onClick={e => e.stopPropagation()}>
            <div style={{ fontSize: 48, marginBottom: 8 }}>{successTitle === "Changes Published" ? "\u2705" : "\uD83D\uDCEB"}</div>
            <h3 className="AdminModalTitle" style={{ marginBottom: 4 }}>{successTitle}</h3>
            <p style={{ fontSize: 13, color: "#64748b", margin: "0 0 20px 0" }}>Changes have been saved.</p>
            <button className="AdminButton AdminSubmitBtn" onClick={() => setShowSuccessOverlay(false)} style={{ display: "block", margin: "0 auto" }}>OK</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminGovtFeeHistoryEditor;
